import { render, staticRenderFns } from "./cadgruposplanospagamento.vue?vue&type=template&id=0bcb0091&"
import script from "./cadgruposplanospagamento.vue?vue&type=script&lang=js&"
export * from "./cadgruposplanospagamento.vue?vue&type=script&lang=js&"
import style0 from "./cadgruposplanospagamento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports